import { forEach } from './lib/util';

export function bindFormEvents() {
   // button submitting animation
   forEach(document.querySelectorAll('form'), el => {
      el.addEventListener('submit', function(event) {
         // get the submitter, or look for the focused submit button if we have to
         const submitter = event.submitter || el.querySelector('button[type=submit]:focus');

         // add class to the button
         submitter.classList.add('cuda-btn-submitting');
         submitter.style.backgroundImage = submitter.style.backgroundImage;
         setTimeout(() => {
            // prevent multiple submits
            // but still allow name / value of submit button to be POSTed
            submitter.disabled = true;
         }, 0);
      });
   });
}
